import {
  buildPickupAssignUpdatePayload,
  buildPickupUpdatePayload,
  getUpdatePickupIds,
} from './swapBoardPayloads';
import {
  applyGroupUpdateFields,
  mergeTrailerFromUpdate,
  upsertTrailersFromPayload,
} from './swapBoardUpsert';
import type { SwapBoardGroup, SwapBoardUpdatePayload, SwapBoardUpdateResult } from './types';

export const updateSwapBoardFromSignalR = (
  apiGroups: SwapBoardGroup[],
  payload: SwapBoardUpdatePayload
): SwapBoardUpdateResult => {
  if (!Array.isArray(apiGroups)) {
    return { groups: apiGroups, updated: false };
  }

  const pickupIds = getUpdatePickupIds(payload);
  if (!pickupIds.length) {
    return { groups: apiGroups, updated: false };
  }

  const pickupIdSet = new Set(pickupIds);
  const normalizedShipperCode = payload.rmaxShipperCode?.toUpperCase?.();
  let updated = false;

  const groups = apiGroups.map((group) => {
    if (
      normalizedShipperCode &&
      group.rmaxShipperCode?.toUpperCase() !== normalizedShipperCode
    ) {
      return group;
    }

    const trailers = (group.trailers || []).map((trailer) => {
      if (!pickupIdSet.has(trailer.pickupId?.toUpperCase?.() ?? '')) {
        return trailer;
      }
      updated = true;
      return mergeTrailerFromUpdate(trailer, payload) ?? trailer;
    });

    return applyGroupUpdateFields({ ...group, trailers }, payload);
  });

  if (!updated) {
    return upsertTrailersFromPayload({ apiGroups: groups, payload, pickupIds });
  }

  return { groups, updated };
};

export type ApplySwapBoardPickupAssignEventParams = {
  apiGroups: SwapBoardGroup[];
  pickupData: SwapBoardUpdatePayload;
  eventName: string;
};

export const applySwapBoardPickupAssignEvent = ({
  apiGroups,
  pickupData,
  eventName,
}: ApplySwapBoardPickupAssignEventParams) =>
  updateSwapBoardFromSignalR(apiGroups, buildPickupAssignUpdatePayload(pickupData, eventName));

export const applySwapBoardPickupUpdateEvent = (
  apiGroups: SwapBoardGroup[],
  pickupData: SwapBoardUpdatePayload
) => updateSwapBoardFromSignalR(apiGroups, buildPickupUpdatePayload(pickupData));
